import { SectionAbout, AboutFigure } from "./style/SectionAbout";
import { MainTitle } from "../GlobalStyle";

const MainAbout = () => {
  return (
    <SectionAbout id="about">
      <MainTitle>Sobre Mim</MainTitle>

      <AboutFigure>
        <figcaption>
          Sou Artur da Silva Rezende, Desenvolvedor Front-end com formação em
          Análise e Desenvolvimento de Sistemas pela Faculdade Nossa Senhora
          Aparecida (FANAP). Tenho foco na criação de interfaces modernas,
          responsivas e performáticas, utilizando tecnologias como React e
          Next.js.
        </figcaption>
      </AboutFigure>

      <span className="about__br"></span>

      <AboutFigure>
        <figcaption>
          Ao longo da minha jornada, desenvolvi projetos próprios que me
          permitiram aplicar na prática conceitos fundamentais como
          componentização, consumo de APIs, criação de aplicações SPA e
          construção de layouts responsivos, sempre com atenção à experiência do
          usuário (UI/UX) e organização de código.
        </figcaption>
      </AboutFigure>

      <span className="about__br"></span>

      <AboutFigure>
        <figcaption>
          Busco constantemente evoluir tecnicamente, aprendendo novas
          ferramentas e boas práticas do ecossistema front-end. Tenho facilidade
          em trabalhar em equipe, sou proativo na resolução de problemas e estou
          sempre aberto a aprender e contribuir com soluções eficientes.
        </figcaption>
      </AboutFigure>
    </SectionAbout>
  );
};

export default MainAbout;
